/**
 * Invia un page_view a Google Analytics a ogni cambio rotta.
 *
 * Va montato a livello globale dentro <BrowserRouter> (es. in AppRoutes), così
 * copre tutte le rotte — pubbliche e autenticate. `trackPageView` è no-op se GA
 * non è attivo (fuori prod, ID assente o consenso non concesso), quindi l'hook
 * può girare sempre senza effetti collaterali.
 */

import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageView } from '@/lib/analytics'

export function usePageViews(): void {
  const location = useLocation()

  useEffect(() => {
    trackPageView(location.pathname + location.search)
  }, [location.pathname, location.search])
}
